module.exports = __webpack_public_path__ + "img/rickmorty.b17de129.png";